module.exports = __webpack_public_path__ + "6488dda7eeaefeb80bfb1d9850cf0606.svg";